import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["hideIcon", "showIcon"];

  swapIcon() {
    var icon;
    if (!this.hideIconTarget.classList.contains("d-none")) {
      icon = this.hideIconTarget;
      icon.classList.remove("fa-eye-slash");
      icon.classList.add("fa-eye");
    } else if (!this.showIconTarget.classList.contains("d-none")) {
      icon = this.showIconTarget;
      icon.classList.remove("fa-eye");
      icon.classList.add("fa-eye-slash");
    }
  }

  restoreIcon() {
    var icon;
    if (!this.hideIconTarget.classList.contains("d-none")) {
      icon = this.hideIconTarget;
      icon.classList.remove("fa-eye");
      icon.classList.add("fa-eye-slash");
    } else if (!this.showIconTarget.classList.contains("d-none")) {
      icon = this.showIconTarget;
      icon.classList.remove("fa-eye-slash");
      icon.classList.add("fa-eye");
    }
  }

  toggle(event) {
    event.preventDefault();

    var url = this.element.dataset.url;

    fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "same-origin",
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        this.restoreIcon();
        this.hideIconTarget.classList.toggle("d-none");
        this.showIconTarget.classList.toggle("d-none");

        if (data.message) {
          window.notyf.success(data.message);
        }
      }.bind(this))
      .catch(function () {
        window.notyf.error("Something went wrong. Please try again.");
      });
  }
}
